import React, { Component } from 'react';

class PrintTreatmentSession extends Component {

    renderProcedureTree(items) {
        return (
            <div className="procedure-tree two-columns">
                {items.map((item) => (
                    <div key={item.id} className="procedure-block">
                        <div className="subtitle">{item.name}</div>

                        {item.children && item.children.length > 0 && (
                            <div className="children">
                                {this.renderProcedureChildren(item.children, 1)}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    }

    renderProcedureChildren(children, level = 1) {
        return (
            <ul className={`child-list level-${level}`}>
                {children.map((child) => (
                    <li key={child.id}>
                        <input type='checkbox' className='checkbox' /> {child.name}
                        {/* Render tiếp các cấp con nếu tồn tại */}
                        {child.children && child.children.length > 0 && (
                            <div className="child-children">
                                {this.renderProcedureChildren(child.children, level + 1)}
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        );
    }

    render() {
        const { customer, data } = this.props;

        const renderDot = (value, dot = "..................................................................") => {
            if (value === null || value === undefined || value === "") {
                return dot;
            }
            return value;
        };

        return (
            <div className="container print-content">
                <div className="title-wrap">
                    <div className="print-date-top">
                        Ngày.........tháng.........năm.........
                    </div>
                    <h1>PHIẾU ĐIỀU TRỊ</h1>
                </div>

                <table className="kv-table mb-4">
                    <tr>
                        <th>Họ và tên khách hàng:</th>
                        <td>{renderDot(customer?.full_name)}</td>
                    </tr>
                    <tr>
                        <th>Mã khách hàng</th>
                        <td>{renderDot(customer?.code)}</td>
                    </tr>
                </table>

                {this.renderProcedureTree(data)}

                <div className="field-wrapper mt-4">
                    <span className="label">ĐIỀU TRỊ KHÁC (nếu có):</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <div className="field-wrapper" style={{ marginTop: 25 }}>
                    <span className="label">LỜI DẶN CỦA BÁC SĨ:</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <div className="field-wrapper" style={{ marginTop: 25 }}>
                    <span className="label">HƯỚNG ĐIỀU TRỊ TIẾP:</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <div className="signature-section mt-4">
                    <div className="sig-box">
                        <strong>Bác sĩ</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name"></div>
                    </div>

                    <div className="sig-box">
                        <strong>Khách hàng</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{customer?.full_name}</div>
                    </div>
                </div>

                <style>
                    {`
                    /* --- Print & Page setup --- */
                    @page {
                        size: A4;
                        margin: 1cm 0.5cm 1cm 0.5cm; /* top, right, bottom, left */
                    }

                    :root {
                        --text: #111;
                        --muted: #666;
                        --border: #ddd;
                        --heading: #000;
                        --primary: #0b2b33;
                    }

                    @media print {
                        .no-print {
                            display: none !important;
                        }

                        .page-break {
                            page-break-before: always;
                        }

                        body {
                            font-family: "Times New Roman", serif;
                            font-size: 11pt;
                            line-height: 1.5;
                            color: #000;
                        }
                        .print-date-top{
                            margin-top: -5mm;
                        }
                    }

                    .print-date-top{
                        margin-bottom: 10px;
                        text-align: right;
                        font-style: italic;
                    }

                    .field-wrapper {
                        display: flex;
                        align-items: center;
                        width: 100%;
                    }

                    .field-wrapper .label {
                        font-weight: 600;  /* theo style subtitle của bạn */
                        margin-right: 6px;
                        white-space: nowrap;
                    }

                    .field-wrapper .dot-line {
                        flex: 1;
                        border-bottom: 1px dotted #000;
                        height: 1px;
                        margin-top: 8px; /* căn cho đẹp */
                    }

                    .dotted-lines .line {
                        border-bottom: 1px dotted #000;
                        height: 22px;       /* chiều cao mỗi dòng */
                        margin-bottom: 6px; /* khoảng cách giữa các dòng */
                        width: 100%;
                    }

                    .print-content h1,
                    .print-content h2,
                    .print-content h3 {
                        margin: 0 0 10px 0;
                        color: var(--heading);
                    }

                    .print-content h1 {
                        text-align: center;
                        font-size: 18pt;
                        letter-spacing: 0.3px;
                    }

                    .print-content h2.section-title {
                        font-size: 13.5pt;
                        padding-left: 8px; */
                        margin: 18px 0 10px 0;
                    }

                    .print-content .line-height-20 {
                        line-height: 20px;
                    }

                    .child-list li {
                        display: flex;
                        align-items: flex-start;
                        gap: 6px;
                        margin: 8px 0;
                        font-size: 13pt;
                        line-height: 1.4;
                    }

                    /* checkbox cố định kích thước */
                    .child-list li .checkbox {
                        width: 18px;
                        height: 18px;
                        flex-shrink: 0;
                        margin-top: 2px; /* giúp căn giữa theo chữ */
                    }

                    /* phần text phải chiếm phần còn lại */
                    .child-list li .item-text {
                        flex: 1;
                        display: block;
                        padding-left: 0;
                        text-align: left;
                        word-break: break-word; 
                    }

                    .print-content .subtitle {
                        font-weight: 600;
                        font-size: 8.5pt;
                    }

                    .print-content ul.child-list.level-1 {
                        margin: 8px 0;
                        list-style-type: none;
                        padding: 0;
                    }

                    .print-content ul.child-list li {
                        margin: 0;
                        font-size: 10pt;
                    }

                    .print-content .checkbox {
                        width: 18px;
                        height: 18px;
                        display: inline-block;
                        border: 1px solid var(--border);
                        margin-right: 2px;
                        vertical-align: middle;
                    }

                    /* --- 2 COLUMN AUTO LAYOUT --- */
                    .procedure-tree.two-columns {
                        column-count: 2;            /* chia 2 cột */
                        column-gap: 40px;           /* khoảng cách giữa 2 cột */
                        width: 100%;
                    }

                    /* Đảm bảo mỗi block không bị tách đôi giữa cột */
                    .procedure-block {
                        break-inside: avoid;        /* tránh bị cắt sang cột khác */
                        -webkit-column-break-inside: avoid;
                        margin-bottom: 15px;
                    }

                    /* danh sách con hiển thị đẹp trong từng mục */
                    .child-list {
                        padding-left: 16px;
                        margin-top: 6px;
                    }

                    /* --- Header --- */
                    .header {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        border-bottom: 1px solid var(--border);
                        padding-bottom: 20px;
                        position: relative;
                    }

                    /* Nhóm bên phải (QR + thông tin) */
                    .header .footer {
                        display: flex;
                        align-items: flex-start;
                        gap: 16px;
                        border: none;
                        padding-top: 0;
                        margin-top: 0;
                    }

                    /* Logo */
                    .logo-box {
                        width: 90px;
                        height: 90px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .logo-box img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }

                    /* QR */
                    .header .footer .qr-box {
                        width: 80px;
                        height: 80px;
                        flex-shrink: 0;
                    }

                    .header .footer .qr-box img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border: 1px solid var(--border);
                        background: #fff;
                        padding: 4px;
                    }

                    /* Clinic info */
                    .header .footer .clinic {
                        text-align: left;
                        margin-left: 8px;
                        font-size: 10.5pt;
                        line-height: 1.4;
                    }

                    .header .footer .clinic .section-title {
                        font-weight: bold;
                        color: var(--primary);
                        margin-bottom: 4px;
                        font-size: 11pt;
                    }

                    .header .footer .clinic span {
                        display: block;
                        font-size: 8px;
                        color: var(--muted);
                        line-height: 1.3;
                    }

                    .title-wrap {
                        margin: 8px 0 16px 0;
                        position: relative;
                    }

                    /* --- Tables --- */
                    table {
                        border-collapse: collapse;
                        width: 100%;
                    }

                    .kv-table td,
                    .kv-table th {
                        border: 0px solid var(--border);
                        padding: 5px 0px;
                        vertical-align: top;
                    }

                    .kv-table th {
                        width: 32%;
                        /* background: #fafafa; */
                        text-align: left;
                        font-weight: 600;
                    }

                    .grid-table th,
                    .grid-table td {
                        border: 1px solid var(--border);
                        padding: 6px 8px;
                        vertical-align: top;
                    }

                    .grid-table th {
                        background: #fafafa;
                    }

                    .narrow td,
                    .narrow th {
                        padding: 5px 6px;
                    }

                    .muted {
                        color: var(--muted);
                    }

                    /* --- Helpers --- */
                    .mb-4 {
                        margin-bottom: 16px;
                    }

                    .mb-2 {
                        margin-bottom: 8px;
                    }

                    .mt-2 {
                        margin-top: 8px;
                    }

                    .mt-4 {
                        margin-top: 16px;
                    }

                    .pt-2 {
                        padding-top: 8px;
                    }

                    .pt-4 {
                        padding-top: 16px;
                    }

                    .pl-2 {
                        padding-left: 8px;
                    }

                    .pl-4 {
                        padding-left: 16px;
                    }

                    .pr-2 {
                        padding-right: 8px;
                    }

                    .pr-4 {
                        padding-right: 16px;
                    }

                    .italic {
                        font-style: italic;
                    }

                    .center {
                        text-align: center;
                    }

                    .right {
                        text-align: right;
                    }

                    .note {
                        color: var(--muted);
                    }

                    @media print {
                        .disease-grid {
                            page-break-inside: avoid;
                        }
                    }

                    .print-date {
                        text-align: right;
                        margin-top: 40px;
                        font-size: 12pt;
                        font-style: italic;
                        color: var(--text);
                    }

                    .signature-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        margin-top: 30px;
                        text-align: center;
                        gap: 60px;
                        margin-bottom: 50px;
                    }

                    .sig-box {
                        flex: 1;
                    }

                    .sig-box strong {
                        font-size: 13pt;
                        display: block;
                        margin-bottom: 2px;
                    }

                    .sig-box .note {
                        color: var(--muted);
                        font-style: italic;
                        font-size: 11pt;
                    }

                    .sig-space {
                        height: 60px;
                        margin: 24px auto 8px auto;
                        width: 80%;
                    }

                    .sig-name {
                        font-weight: bold;
                        font-size: 12pt;
                        color: var(--primary);
                        text-transform: uppercase;
                    }
                    `}
                </style>

            </div >
        );
    }
}

export default PrintTreatmentSession;
